import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full min-h-[70vh] flex flex-col items-center justify-center text-center px-4 pt-24 md:pt-28 pb-16">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 mb-6">
        <i className="ri-emotion-sad-line text-3xl text-primary-600"></i>
      </span>
      <h1 className="text-2xl md:text-4xl font-label font-bold text-foreground-950">
        哎呀，这一页跑丢了
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600">
        没有找到路径
        <span className="mx-1 px-2 py-0.5 rounded bg-background-100 font-mono text-xs md:text-sm text-foreground-700">
          {location.pathname}
        </span>
        对应的页面
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label font-bold hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          回到首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-label font-bold hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-newspaper-line"></i>
          浏览资讯
        </Link>
      </div>
    </div>
  );
}